import React, { useEffect, useState } from "react";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { GROUP_SETTING } from "../apiClient/apiEndpoints";
import { useParams } from "react-router-dom";
import apiClient from "../apiClient";


const initialSettings = {
    inherit: false,
    handDown: false,
    parent: { handDown: false }
}
const { useUnoSelector } = UnoStoreHooks;
const { SimToggleSwitch } = UiComponents;


const SettingTeamManagement = ({ type }) => {
    const configData = useUnoSelector((state) => state.config);
    const userData = useUnoSelector((state) => state.user);
    const params = useParams();
    const UUID = params?.uuid;
    const [settings, setSettings] = useState(initialSettings);

    const fetchSettings = async () => {
        try {
            const data = await apiClient.get(`${configData.config.UNO_URL}${GROUP_SETTING}/${type}/${UUID}`);
            setSettings({ ...initialSettings, ...data });
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        setSettings(initialSettings);
        fetchSettings();
    }, [UUID]);

    const updateSettings = async (postData) => {
        try {
            setSettings(pre => ({ ...pre, ...postData }));
            await apiClient.post(`${configData.config.UNO_URL}${GROUP_SETTING}/${type}/${UUID}`, { ...postData })
            fetchSettings();
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <>
            <div className="function-item">
                <h6>Group Settings</h6>
                <div className="group-info-item">
                    <div className="text-detail">
                        <p> Unristricted </p>
                        <div className="toggle-function">
                            <SimToggleSwitch checked={settings.handDown} onChange={() => updateSettings({ "handDown": !settings.handDown })} />
                        </div>
                    </div>
                    <p className="info-message"> Grant all applications and resources access to all direct sub-groups/users </p>
                </div>
                <div className="group-info-item">
                    <div className="text-detail">
                        <p> Inherited </p>
                        <div className="text-output">
                            <SimToggleSwitch disabled={settings.parent.handDown || (userData.user.group.uuid === UUID)} checked={settings.parent.handDown || settings.inherit} onChange={() => updateSettings({ "inherit": !settings.inherit })} />
                        </div>
                    </div>
                    <p className="info-message"> Inherit all applications and resources from Parent Group </p>
                </div>
            </div>
        </>
    )
}

export default SettingTeamManagement;